<template>
  <div class="vue-gmap position-relative h-100">
    <Spinner :size="loadingOptions.size"  :line-bg-color="loadingOptions.lineBgColor"  v-if="loading.status && !initialPopup && !proceed" class="position-absolute vue-map-loading" />
    <div class="form-group live-mode-form-group p-2 d-none" v-if="!initialPopup">
      <input type="checkbox" id="liveModeCheck" v-model="liveMode" class="live-mode-form-check-input">
      <label for="liveModeCheck" class="god-mode-form-check-label p-0 m-0">
        {{ text.move_card }}
      </label>
    </div>
    <div class="back-to-center" v-if="backToCenterStatus">
      <a class="btn center-btn" href="#" @click="backToCenter">{{ text.back_center }}</a>
    </div>
    <GmapMap
            :center="center"
            :options="mapOptions"
            @center_changed="centerChanged"
            @dragend="dragEnd"
            :zoom="zoom"
            ref="map"
            style="height: 100%"
    >
      <map-popup :marker="infoContent" :centerPopup="centerPopup" :infoWindowPos="infoWindowPos" :infoWinOpen="infoWinOpen" @closePopup="closePopup" ></map-popup>
        <GmapMarker
            :icon="centerIcon"
            :position="center"
            :clickable="true"
            v-if="!centerFromMap.geometry || proceed || !liveMode"
        />
        <GmapMarker
            :icon="centerIcon"
            :position="centerFromMap.geometry"
            :clickable="true"
            v-if="centerFromMap.geometry && liveMode"
        />
      <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :icon="generateIcon(m)"
              :position="m.position"
              :clickable="true"
              @click="toggleInfoWindow(m, index , true)"
              v-if="m.visible && m.status === '1'"
      />
    </GmapMap>
  </div>
</template>

<script>

import MapPopup from '@/components/MapPopup'
import { mapState } from 'vuex'
import {gmapApi} from 'vue2-google-maps'
import Spinner from 'vue-simple-spinner'
import ServiceDrupal from '@/services/ServiceDrupal.js'

export default {
    name: 'GoogleMap',
    components: {
        MapPopup,
        Spinner
    },
    data () {
        return {
            text: {
                move_card: Drupal.t('Search when the card is moved'),
                back_center: Drupal.t('Back to center')
            },
            mapOptions: {
                panControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                overviewMapControl: false,
                type: 'roadmap',
                styles: [
                    {
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#f5f5f5'
                            }
                        ]
                    },
                    {
                        'elementType': 'labels.icon',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#616161'
                            }
                        ]
                    },
                    {
                        'elementType': 'labels.text.stroke',
                        'stylers': [
                            {
                                'color': '#f5f5f5'
                            }
                        ]
                    },
                    {
                        'featureType': 'administrative',
                        'elementType': 'labels',
                        'stylers': [
                            {
                                'visibility': 'on'
                            }
                        ]
                    },
                    {
                        'featureType': 'administrative.country',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#777777'
                            },
                            {
                                'weight': 1.5
                            }
                        ]
                    },
                    {
                        'featureType': 'administrative.country',
                        'elementType': 'geometry.fill',
                        'stylers': [
                            {
                                'color': '#ffeb3b'
                            }
                        ]
                    },
                    {
                        'featureType': 'administrative.country',
                        'elementType': 'labels',
                        'stylers': [
                            {
                                'color': '#2a2a2a'
                            }
                        ]
                    },
                    {
                        'featureType': 'administrative.country',
                        'elementType': 'labels.text.stroke',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'administrative.land_parcel',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#bdbdbd'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#eeeeee'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#757575'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi.park',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#e5e5e5'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi.park',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#9e9e9e'
                            }
                        ]
                    },
                    {
                        'featureType': 'road',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#ffffff'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.arterial',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#757575'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.highway',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#dadada'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.highway',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#616161'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.local',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#9e9e9e'
                            }
                        ]
                    },
                    {
                        'featureType': 'transit.line',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#e5e5e5'
                            }
                        ]
                    },
                    {
                        'featureType': 'transit.station',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#eeeeee'
                            }
                        ]
                    },
                    {
                        'featureType': 'water',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#c8d6d3'
                            }
                        ]
                    },
                    {
                        'featureType': 'water',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#9e9e9e'
                            }
                        ]
                    }
                ]
            },
            centerFromMap: {
                geometry: null
            },
            zoomFromMap: 6,
            storeIconNormal: {
                url: process.env.IMAGES_FOLDER + 'map-marker-normal.png'
            },
            storeIconActive: {
                url: process.env.IMAGES_FOLDER + 'map-marker-active.png'
            },
            centerIcon: {
                url: process.env.IMAGES_FOLDER + 'map-pointer.png'
            },
            dynamicCenterIcon: {
                url: process.env.IMAGES_FOLDER + 'map-dynamic.png'
            },
            infoWindowPos: null,
            infoWinOpen: false,
            currentMidx: null,
            currentMarker: null,
            backToCenterStatus: false,
            loadingOptions: {
                size: 'massive',
                lineBgColor: 'transparent',
                linefgColor: '#000000'
            }
        }
    },
    watch: {
        selectedStore () {
            if (this.selectedStore) {
                if (this.selectedStore.source !== 'left') {
                    this.$store.dispatch('store/setActive', {
                        id: this.selectedStore.id
                    })
                    if (this.selectedStore.source === 'list') {
                        this.selectMarker(this.selectedStore)
                    }
                }
            }
        }
    },
    computed: {
        google: gmapApi,
        markers: {
            get () {
                return this.$store.state.store.markers
            },
            set (value) {
                this.$store.commit('store/SET_MARKERS', value)
            }
        },
        liveMode: {
            get () {
                return this.$store.state.map.liveSearch
            },
            set (value) {
                this.$store.commit('map/SET_LIVE_SEARCH', value)
            }
        },
        infoContent: function () {
            if (this.currentMarker) { return this.currentMarker }
        },
        centerPopup: function () {
            if (this.infoWindowPos === this.center) {
                return true
            }
            return false
        },
        ...mapState({
            place: state => state.map.place,
            radius: state => state.map.radius,
            center: state => state.map.center,
            zoom: state => state.map.zoom
        }),
        ...mapState([
            'selectedStore',
            'initialPopup',
            'proceed',
            'loading'
        ])
    },
    methods: {
        selectMarker (marker) {
            this.toggleInfoWindow(marker, marker.id, false)
        },
        closePopup () {
            this.infoWinOpen = false
            this.centerFromMap.geometry = null
            this.$store.dispatch('store/setActive', {
                id: 0
            })
        },
        backToCenter () {
            this.$store.dispatch('setStore', null)
            this.$store.dispatch('startLoading', { message: 'Resetting to center ...' })
            this.$store.dispatch('map/updateRadius', this.radius)
            this.$store.dispatch('map/updatePlace', this.place)
            this.$store.dispatch('store/update', {
                google: this.google,
                radius: this.radius,
                place: this.place,
                center: this.center,
                live: true
            })
            this.$refs.map.panTo({
                lat: this.center.lat,
                lng: this.center.lng
            })
            this.$store.dispatch('stopLoading')
            this.centerFromMap.geometry = null
            this.backToCenterStatus = false
        },
        generateIcon (marker) {
            if (marker.active) {
                return this.storeIconActive
            }
            return this.storeIconNormal
        },
        convertZoomToRadius (zoom) {
            if (zoom > 12) {
                return 5
            } else if (zoom > 11) {
                return 10
            } else if (zoom > 10) {
                return 25
            } else if (zoom > 9) {
                return 50
            } else if (zoom > 8) {
                return 100
            } else if (zoom > 7) {
                return 200
            } else if (zoom > 6) {
                return 300
            } else if (zoom > 5) {
                return 600
            } else {
                return 1500
            }
        },
        centerChanged (center) {
            this.backToCenterStatus = true
            if (center) {
                this.centerFromMap.geometry = {
                    lat: center.lat(), lng: center.lng()
                }
            }
        },
        dragEnd () {
            this.liveMode = true;
            this.liveUpdate()
        },
        liveUpdate () {
            this.infoWinOpen = false
            this.$store.dispatch('startLoading', { message: Drupal.t('Searching for place ...') })
            let radius = this.convertZoomToRadius(this.zoom)
            this.$store.dispatch('setStore', null)
            this.$store.dispatch('store/update', {
                google: this.google,
                radius: radius,
                place: this.centerFromMap,
                center: this.centerFromMap.geometry,
                live: true
            })
            this.$store.dispatch('stopLoading')
        },
        toggleInfoWindow (marker, idx, updateMarker) {
            this.liveMode = false;
            this.infoWindowPos = marker.position
            this.centerFromMap.geometry = null
            // Set selected store
            if (updateMarker) {
                this.$store.dispatch('setStore', {
                    source: 'map',
                    store: marker
                })
                this.$refs.map.panTo({
                    lat: this.infoWindowPos.lat,
                    lng: this.infoWindowPos.lng
                })
            }
            this.currentMarker = marker
            // check if its the same marker that was selected if yes toggle
            if (this.currentMidx === idx) {
                this.infoWinOpen = !this.infoWinOpen
            } else {
                this.infoWinOpen = true
                this.currentMidx = idx
            }
        }
    },
    mounted () {
        //  this.addYourLocationButton()
    }

}
</script>

<style  scoped>

</style>
